export default __webpack_public_path__ + "static/media/logo.42d862ab.svg";